// import helpers from '../common/helpers';


(function ($) {
  "use strict";

  const cntsAbout = {
    init: function () {
      this.setup();
      this.start();
    },
    setup() {
      this.options = {
      };
    },
    start() {
      $(".our-story .timeline-box")
        .mouseover(function () {
          $(this).addClass("timeline-box--highlight");
        })
        .mouseout(function () {
          $(this).removeClass("timeline-box--highlight");
        });
    }
  };

  $(document).ready(function () {
    if ($('body').hasClass('page-template-page-about')) {
      cntsAbout.init();
    }
  });

  $(window).resize(function () {
  });

})(jQuery);